export type KpiSummaryData = {
  type: KpiDataPoint,
  value: number,
  currency?: string,
  yoy?: number
}

export enum KpiDataPoint {
  TOTAL_GROSS_SALES_REVENUE = 'total-gross-sales-revenue',
  AVERAGE_BOOKING_VALUE = 'average-booking-value',
  TOTAL_NET_REVENUE = 'total-net-revenue',
  TOTAL_BOOKINGS = 'total-bookings',
  TOTAL_NIGHTS = 'total-nights',
  AVERAGE_LENGTH_OF_STAY_IN_NIGHTS = 'average-length-of-stay-in-nights',
  AVERAGE_LEAD_TIME_IN_DAYS = 'average-lead-time-in-days',
  TOTAL_REVENUE = 'total-revenue',
  AVERAGE_MARK_UP = 'average-mark-up'
}
